<template>
  <div class="dlt">
    <span class="dlt-dot"></span>
    <div class="dlt-items-wrap">
      <div class="dlt-feed" :style="{ transform: `translateY(-${idx * 46}px)`, transition: transitioning ? 'transform .5s cubic-bezier(.4,0,.2,1)' : 'none' }">
        <div v-for="(item, i) in items" :key="i" class="dlt-item">
          <b>{{ item.action }}</b>
          <span class="dlt-mute">em</span>
          <span class="dlt-acc">{{ item.vsl }}</span>
          <span class="dlt-mute">· {{ item.time }}</span>
        </div>
      </div>
    </div>
    <span class="dlt-live mono">LIVE · UTC-3</span>
  </div>
</template>

<script>
export default {
  name: 'DashLiveTicker',
  props: {
    items: {
      type: Array,
      default: () => [
        { action: 'Lead capturado',    vsl: 'VSL Webinar Lançamento',   time: 'há 4s' },
        { action: 'Play registrado',   vsl: 'Pitch Curso Copy',         time: 'há 11s' },
        { action: 'CTA clicado (7:42)', vsl: 'VSL Principal',           time: 'há 18s' },
        { action: 'Lead capturado',    vsl: 'Chat Bot Home',            time: 'há 23s' },
      ],
    },
  },
  data() {
    return { idx: 0, transitioning: true, _timer: null }
  },
  mounted() {
    this._timer = setInterval(this.tick, 3200)
  },
  beforeDestroy() { clearInterval(this._timer) },
  methods: {
    tick() {
      const len = this.items.length
      const next = (this.idx + 1) % len
      if (next === 0) {
        this.transitioning = true
        this.idx = len
        setTimeout(() => {
          this.transitioning = false
          this.idx = 0
          setTimeout(() => { this.transitioning = true }, 20)
        }, 500)
      } else {
        this.transitioning = true
        this.idx = next
      }
    },
  },
}
</script>

<style>
.dlt {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 48px;
  padding: 0 22px;
  background: rgba(40,199,111,.05);
  border: 1px solid rgba(40,199,111,.15);
  border-radius: 12px;
  margin-bottom: 20px;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}
.dlt-dot {
  width: 8px; height: 8px;
  background: #28C76F;
  border-radius: 50%;
  flex-shrink: 0;
  animation: wr-pulse 2s infinite;
}
.dlt-items-wrap {
  flex: 1;
  height: 46px;
  overflow: hidden;
  position: relative;
}
.dlt-feed {
  position: absolute;
  top: 0; left: 0; right: 0;
  display: flex;
  flex-direction: column;
}
.dlt-item {
  height: 46px;
  line-height: 46px;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 13.5px;
  color: var(--wr-text);
}
.dlt-item b { font-weight: 700; flex-shrink: 0; }
.dlt-mute { color: var(--wr-mute); flex-shrink: 0; }
.dlt-acc { color: #F5B935; font-weight: 700; overflow: hidden; text-overflow: ellipsis; min-width: 0; }
.dlt-live { font-family: 'JetBrains Mono', monospace; font-size: 11px; color: var(--wr-mute); letter-spacing: .5px; flex-shrink: 0; white-space: nowrap; }
</style>
